// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blockquote {\r\n  padding: 10px 10px;\r\n  border-left: 5px solid #aaaaff;\n}\r\n", ""]);
// Exports
module.exports = exports;
